import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/nav.scss";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NavLogo from "./images/logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import Divider from "@mui/material/Divider";
export default function Nav() {
  const navigate = useNavigate();
  const [accessLevel, setAccessLevel] = useState(null);
  // MENU SECTION START ------
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //MENU SECTION END -----
  useEffect(() => {
    let _accessLevel = localStorage.getItem("access");
    setAccessLevel(_accessLevel);
  }, []);

  return (
    <nav>
      <img src={NavLogo} id="nav-logo" onClick={() => navigate("/home")} />

      <MenuIcon
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        fontSize="large"
        className="menu-button"
        style={{ cursor: "pointer" }}
      />

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            navigate("/home");
            handleClose();
          }}
        >
          Asset Management
        </MenuItem>{" "}
        <Divider />
        <MenuItem
          onClick={() => {
            navigate("/list-management");
            handleClose();
          }}
        >
          List Management
        </MenuItem>
        <Divider />
        {accessLevel && accessLevel == process.env.REACT_APP_ADMIN_ID ? (
          <>
            <MenuItem
              onClick={() => {
                navigate("/user-management");
                handleClose();
              }}
            >
              User Management
            </MenuItem>
            <Divider />
          </>
        ) : null}
        {accessLevel && accessLevel == process.env.REACT_APP_ADMIN_ID ? (
          <>
            <MenuItem
              onClick={() => {
                navigate("/admin-management");
                handleClose();
              }}
            >
              Admin Management
            </MenuItem>{" "}
            <Divider />
          </>
        ) : null}
        <MenuItem
          onClick={() => {
            navigate("/");
            localStorage.clear();
            handleClose();
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </nav>
  );
}
